export default __webpack_public_path__ + "static/media/VysehradDeti.6196feb1.jpg";